import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LoaderStatus } from 'libs/core/src/lib/model/loading/loading-status.enum';
import { HeaderService } from 'libs/core/src/lib/service/header.service';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';
import { StateService } from 'libs/core/src/lib/state/state.service';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { ActivatedRoute } from '@angular/router';
import { AuthStateService } from 'libs/core/src/lib/state/auth.state.service';
import { FlowService } from 'libs/core/src/lib/service/flow.service';
import { FlowType } from 'libs/core/src/lib/model/component/steps/flow-type.model';

@Component({
  template: ''
})
export class RefundPageComponent implements OnInit, AfterViewInit, OnDestroy {
  public lang: string = null;
  public loaderStatus = LoaderStatus.pending;

  public allowTimeBeforeScreening: number;
  private queryParamsSubscription: Subscription = Subscription.EMPTY;

  bookingNo: string;
  voucherNo: string;
  email: string;

  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    protected translateService: TranslateService,
    protected headerService: HeaderService,
    protected stateService: StateService,
    protected loaderService: LoaderService,
    protected route: ActivatedRoute,
    protected authService: AuthStateService,
    protected flowService: FlowService
  ) {
    this.allowTimeBeforeScreening = this.environment.constants?.refundAllowTimeBeforeScreening ?? 30;
    flowService.FlowType = FlowType.Refund;
  }

  ngOnInit() {
    this.lang = this.stateService.getItem('lang');

    this.queryParamsSubscription = this.route.queryParams.subscribe((params) => {
      this.bookingNo = params['bookingNo'];
      this.voucherNo = params['voucherNo'];

      if (this.authService.userIsLoggedAndTokenIsValid()) {
        this.email = this.authService.getUser().email;
      }

      this.onLoaderStateChange(LoaderStatus.stopped);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.headerService.setInnerContent(this.translateService.instant('refund.header')), 100);
  }

  ngOnDestroy(): void {
    this.headerService.setInnerContent(null);

    if (this.queryParamsSubscription !== Subscription.EMPTY) {
      this.queryParamsSubscription.unsubscribe();
      this.queryParamsSubscription = Subscription.EMPTY;
    }
  }

  onLoaderStateChange(state: LoaderStatus) {
    this.loaderStatus = state;
    if (state === LoaderStatus.pending) {
      this.loaderService.showLoader(LoaderEnum.MAIN);
      return;
    }

    this.loaderService.hideLoader(LoaderEnum.MAIN);
  }
}
